import { z } from 'zod';

const SubscriptionBillingProviderSchema = z.enum(['STRIPE', 'NONE']);
const SubscriptionBillingProviderStateSchema = z.enum([
  'UNPAID',
  'OVERDUE',
]);
const SubscriptionAllowedActionsSchema = z.enum([
  'EDIT',
  'DELETE',
  'BILLING_PORTAL',
  'CHECKOUT',
]);

const SeatsSchema = z.object({
  user: z.number(),
});

const SubscriptionAssignableToSchema = z.enum(['Normal']);

const UsageSchema = z.object({
  applicationId: z.string(),
  applicationName: z.string(),
  applicationDisplayName: z.string(),
  applicationDescription: z.string(),
  yearMonth: z.string(),
  usedTokens: z.number(),
});

const BaseSubscriptionSchema = z.object({
  active: z.boolean(),
  allowedActions: z
    .array(SubscriptionAllowedActionsSchema)
    .optional(),
  billingProvider: SubscriptionBillingProviderSchema,
  billingProviderState:
    SubscriptionBillingProviderStateSchema.nullable(),
  id: z.string(),
  inactiveAt: z.date().nullable().optional(),
  name: z.string(),
  privilegedWriteOnly: z.boolean(),
  trial: z.boolean(),
});

const SeatSubscriptionSchema = BaseSubscriptionSchema.extend({
  type: z.literal('Seat'),
  assignableTo: SubscriptionAssignableToSchema,
  desiredTotalSeats: SeatsSchema,
  seatsTotal: SeatsSchema,
  seatsUsed: SeatsSchema,
});

const UsageSubscriptionSchema = BaseSubscriptionSchema.extend({
  type: z.literal('Usage'),
  usages: z.array(UsageSchema),
});

export const SubscriptionSchema = z.discriminatedUnion('type', [
  SeatSubscriptionSchema,
  UsageSubscriptionSchema,
]);
export type Subscription = z.infer<typeof SubscriptionSchema>;

export const SubscriptionBillingPortalSchema = z.object({
  billingPortalUrl: z.string(),
});
export type SubscriptionBillingPortal = z.infer<
  typeof SubscriptionBillingPortalSchema
>;
export const CheckOutLinkSchema = z.object({
  checkoutUrl: z.string(),
});
export type CheckOutLink = z.infer<typeof CheckOutLinkSchema>;
